import React from 'react';
import styles from "@/app/page.module.css";

const DOCTOR_IMAGE = "/assets/images/doctor-image.png";
const DOCTOR_BG = "/assets/images/doctor.bg.svg";

export default function DoctorProfile() {
  return (
    <section className={styles.doctorProfileSection}>
      {/* <img
        src={DOCTOR_BG}
        alt="Decorative background"
        aria-hidden="true"
        className={styles.doctorProfileBg}
      /> */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 901 723" fill="none" className={styles.doctorProfileBg}>
        <path opacity="0.1" d="M0 110.943C0 95.4887 11.7408 82.5629 27.1242 81.0815L867.611 0.140884C885.235 -1.55627 900.487 12.2979 900.487 30.0027V692.054C900.487 709.759 885.235 723.613 867.611 721.916L27.1243 640.975C11.7408 639.494 0 626.568 0 611.113V110.943Z" fill="#00B7C3" />
      </svg>

      <div className={styles.doctorProfileInner}>
        <div className={styles.doctorProfileImage}>
          <img
            src={DOCTOR_IMAGE}
            alt="Dr Naveed"
            className={styles.doctorProfileImg}
          />
        </div>

        <div className={styles.doctorProfileContent}>
          <h2 className={styles.doctorProfileHeading}>
            Excellence in ENT & Facial Surgery
          </h2>
          <p className={styles.doctorProfileText}>
            Mr Basheeth is an internationally trained Head & Neck Surgeon with expertise in
            ENT and Facial Plastic Surgery, bringing experience from leading institutions
            across five countries.
          </p>
          <p className={styles.doctorProfileListIntro}>
            My multifaceted subspecialisation encompasses:
          </p>
          <ul className={styles.doctorProfileList}>
            <li>Benign and Malignant Head and Neck Ablative and Reconstructive Surgeries</li>
            <li>Sialendoscopy</li>
            <li>Minimally Invasive Salivary Procedures</li>
            <li>Robotic Head and Neck Surgery (Intuitive Certified)</li>
            <li>Complex Thyroid and Parathyroid Disorders</li>
            <li>Facial Reanimation</li>
            <li>Skin Cancer Surgery</li>
            <li>Laser and Coblation Procedures</li>
            <li>Advanced Facial Plastic</li>
            <li>Functional and Aesthetic Surgeries including Septorhinoplasty</li>
            <li>Otoplasty for Prominent Ears</li>
            <li>Face Lift, Neck Lift, Blepharoplasty, Cosmetic Procedures</li>
            <li>Advanced Endoscopic Sinus Surgery</li>
            <li>Endoscopic Surgery for Blocked Tear Ducts (DCR)</li>
            <li>Sleep/OSA Surgery</li>
            <li>Coblation Procedures for Tonsils, Adenoids</li>
            <li>Allergic Nose (Turbinates)</li>
            <li>Sleep Surgery</li>
            <li>Endoscopic Ear Surgery.</li>
            <li>Laser microsurgery for cancerous and non-cancerous throat conditions.</li>
          </ul>
          <a href="#book" className={styles.doctorProfileButton}>
            MEET DR NAVEED
          </a>
        </div>
      </div>
    </section>
  );
}
